// The browser's Supabase client: the publishable key and the hub schema, so no query can fall
// through to the Accelerator's tables in public (docs/data-model.md, section 2).
// The hub never calls signInWithOtp, signUp, resend, resetPasswordForEmail, reauthenticate or
// updateUser with a new email: each would have Supabase Auth send an email (decision 41).
import { createClient } from '@supabase/supabase-js'
import { ENV, CONFIGURED } from './env.js'

export const supabase = CONFIGURED
  ? createClient(ENV.supabaseUrl, ENV.publishableKey, {
      db: { schema: 'hub' },
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        // nothing is taken from the address bar: the login link's page (/sign-in) reads its own token
        // and uses it only when Log in is pressed (screens/SignIn.jsx), so a scanner opening it uses nothing
        detectSessionInUrl: false,
      },
    })
  : null

// Throws the Data API's error, so a screen's loader can show it once.
export function must({ data, error }) {
  if (error) throw error
  return data
}
